import type { PolypadTool, toolOption } from 'comps/learnosity/v1/type/IPolypad';
import type { Reducer } from 'redux';

import { ACTIONS } from 'actions/polypad-tool-states';

type InitialState = {
  tool?: PolypadTool;
  toolsOption?: toolOption;
  toolColor?: string;
  isUndo?: boolean;
  isRedo?: boolean;
  polypadStatus?: boolean;
};

type PolypadToolsReducer = Reducer<InitialState>;

const initialState: InitialState = {
  tool: undefined,
  toolsOption: undefined,
  toolColor: undefined,
  isUndo: false,
  isRedo: false,
  polypadStatus: false,
};

const reducer: PolypadToolsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === ACTIONS.SET_ACTIVE_TOOL) {
    return {
      ...state,
      tool: payload.tool,
    };
  }

  if (type === ACTIONS.SET_ACTIVE_TOOL_OPTION) {
    return {
      ...state,
      toolsOption: payload.toolsOption,
    };
  }

  if (type === ACTIONS.SET_POLYPAD_ACTIVE) {
    return {
      ...state,
      polypadStatus: payload.polypadStatus,
    };
  }

  if (type === ACTIONS.SET_ACTIVE_TOOL_COLOR) {
    return {
      ...state,
      toolColor: payload.toolColor,
    };
  }

  if (type === ACTIONS.SET_UNDOUBLE_OR_REDOUBLE) {
    return {
      ...state,
      isUndo: !!payload.isUndo,
      isRedo: !!payload.isRedo,
    };
  }

  return state;
};

export default reducer;
